import React from "react";
import Doughnut from "./Doughnut";
import StatsUtils from "../../../../../utils/stats";
import CountUp from "react-countup";
import Spinner from "../../../components/Spinner";
import { FormattedMessage } from "react-intl";
import { getCurrentSummaryData, getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { connect } from "react-redux";

const GlobalKpiViewNumber = props => {
  let data = props.data || {};
  //let data = _data.data || [];
  let dataBySector = data.bySector || {};
  //const valuesArray = data.map(data => data && data.v);
  const oldestValue = 0;
  const newestValue = dataBySector.value || 0;
  const indicator = dataBySector.value || 0;
  const kpi = props.kpi || {};
  const trend = Math.sign(newestValue - oldestValue);
  const color = "#DB1E08";

  return (
    <div className="p-al-r-center p-w-h-100">
      <div className="p-al-r-full-center p-w-1-3" style={{ backgroundColor: color, width: "34%" }}>
        <div
          className={`icon-${StatsUtils.kpiToIconClassName(props.kpi)}`}
          style={{ fontSize: "6vh", color: "#fff" }}
        />
      </div>
      <div className="p-al-r-full-center p-w-2-3 p-pdg-full">
        <div>
          <h2 className="p-page-subtitle p-txt-center" style={{ fontSize: 20 }}>
            {props.title ? (
              <FormattedMessage id={props.title} defaultMessage={props.title}>
                {txt => <React.Fragment>{txt}</React.Fragment>}
              </FormattedMessage>
            ) : null}
          </h2>
          <div
            className="p-txt-center"
            style={{
              fontWeight: "bold",
              marginTop: "5%",
              fontSize: "4vh"
            }}
          >
            <CountUp
              start={0}
              end={StatsUtils.roundKpiValue(kpi, indicator)}
              duration={3}
              separator=" "
              style={{ fontSize: "4vh" }}
              decimals={indicator % 1 === 0 ? 0 : 2}
              formattingFn={v => {
                return StatsUtils.formatKpiValue(kpi, v);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const GlobalKpiView = props => {
  let data = props.data || {};
  let dataBySector = data.bySector || {};
  const oldestValue = 0;
  const newestValue = dataBySector.value || 0;
  const kpi = props.kpi || {};
  const title = kpi.long_label || "";

  if (dataBySector.format === "%") {
    return (
      <React.Fragment>
        <h2 className="p-page-subtitle p-txt-center" style={{ fontSize: 20 }}>
          <FormattedMessage id={title} defaultMessage={title}>
            {txt => <React.Fragment>{txt}</React.Fragment>}
          </FormattedMessage>
        </h2>
        <div
          className="p-mrg-top-s p-al-r-full-center p-flex-1"
          style={{
            height: "calc(100% - 20px)",
            position: "relative"
          }}
        >
          {props.loading ? (
            <Spinner />
          ) : (
            <Doughnut
              newestPercentage={newestValue}
              oldestPercentage={oldestValue}
              kpi={kpi}
              circleTitle={props.circleTitle}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="p-al-c-center p-flex-1" style={{ height: "100%", overflow: "hidden", position: "relative" }}>
        {props.loading ? <Spinner /> : <GlobalKpiViewNumber {...props} />}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    data: getCurrentSummaryData(state),
    loading: getTableLoading(state),
    kpi: getSummaryKpiSelected(state)
  };
};
export default connect(mapStateToProps, null)(GlobalKpiView);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/GlobalKpiView.js